import { GoogleAnalytics } from '../../../App/global/functions/analytics';

export function initializeTagManagerTags() {
    var analytics = new GoogleAnalytics();

    var creditClaimCancelButton = document.querySelector("[data-tag-credit-claim-cancel]") as HTMLElement;
    if (creditClaimCancelButton) {
        creditClaimCancelButton.addEventListener('click', (e) => {
            analytics.onCreditClaimCancelClick();
        });
    }

    var creditClaimConfirmButton = document.querySelector("[data-tag-credit-claim-confirm]") as HTMLElement;
    if (creditClaimConfirmButton) {
        creditClaimConfirmButton.addEventListener('click', (e) => {
            analytics.onCreditClaimConfirmClick();
        });
    }

    var generateCertificateButton = document.querySelector("[data-tag-certificate-generate]") as HTMLElement;
    if (generateCertificateButton) {
        generateCertificateButton.addEventListener('click', (e) => {
            analytics.onCertificateGenerateClick();
        });
    }

    var printCertificateButton = document.querySelector("[data-tag-certificate-print]") as HTMLElement;
    if (printCertificateButton) {
        printCertificateButton.addEventListener('click', (e) => {
            analytics.onCertificatePrintClick();
        });
    }

    var downloadCertificateButton = document.querySelector("[data-tag-certificate-download]") as HTMLElement;
    if (downloadCertificateButton) {
        downloadCertificateButton.addEventListener('click', (e) => {
            analytics.onCertificateDownloadClick();
        });
    }

    var certificateBackButton = document.querySelector("[data-tag-certificate-back]") as HTMLElement;
    if (certificateBackButton) {
        certificateBackButton.addEventListener('click', (e) => {
            analytics.onCertificateBackClick();
        });
    }

    var annualTranscriptsPrint = document.querySelector("[data-tag-annual-print]") as HTMLElement;
    if (annualTranscriptsPrint) {
        annualTranscriptsPrint.addEventListener('click', (e) => {
            analytics.onAnnualTranscriptsPrintClick();
        });
    }
    
}